
  <nav class="navbar navbar-expand-lg navbar-dark   mb-3 head-top container-fluid fixed-top" >
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-3 logo-m-v col-6">
          <a class="navbar-brand">
            <img class="header-logo" [src]="imageURL" alt="">
           
        </a>
        </div>
        
        <!-- <ng-container>
            <div class="col-md-6 col-6 col-xs text-center">
              <h3 class="mt-3" *ngIf="basepath== 'top5'">Top5 Colleges</h3>
            </div>
          </ng-container> -->
      </div>
    </div>
  </nav>